module.exports = __webpack_public_path__ + "static/media/bg-client.6b5a903c.png";